import React from 'react';
import { Button, Icon, message } from 'components';

interface MessageExportButtonProps {
  isValidExport: boolean;
  exportPath: string;
}

const MessageExportButton: React.FC<MessageExportButtonProps> = ({
  isValidExport,
  exportPath,
}) => {
  const onExport = () => {
    if (!isValidExport) {
      message.error(
        'There are too many conversations to export. Please narrow your search.',
      );
    } else {
      window.open(exportPath, '_blank');
    }
  };
  return (
    <div>
      <Button onClick={onExport}>
        <Icon type="download" /> Export
      </Button>
    </div>
  );
};

export default MessageExportButton;
